import {Injectable} from '@angular/core';
import {IStorageCache} from '@interface/services/storage-cache';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private readonly cache: IStorageCache;
  private readonly storageKey: string;
  private isStorageAvailable = true;

  constructor() {
    this.cache = Object.create(null);
    this.storageKey = 'taeik_local_storage';
    this.loadCashFromStorage();
  }

  public get<T>(key: string): T | null {
    return (this.cache[key] as T | undefined) ?? null;
  }

  public remove(key: string): void {
    if (key in this.cache) {
      delete this.cache[key];
      this.persistCache();
    }
  }

  public set(key: string, value: unknown): void {
    this.cache[key] = value;
    this.persistCache();
  }

  public loadCashFromStorage(): void {
    if (!this.isStorageAvailable) {
      return;
    }

    try {
      const serializedData = window.localStorage.getItem(this.storageKey);
      if (!serializedData) {
        return;
      }

      const parsedData: unknown = JSON.parse(serializedData);
      if (!this.fun_isStorageCache(parsedData)) {
        this.fun_resetCorruptedStorage();
        return;
      }

      Object.assign(this.cache, parsedData);
    } catch {
      this.fun_resetCorruptedStorage();
    }
  }

  private persistCache(): void {
    if (!this.isStorageAvailable) {
      return;
    }

    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(this.cache));
    } catch {
      this.isStorageAvailable = false;
    }
  }

  private fun_isStorageCache(value: unknown): value is IStorageCache {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  private fun_resetCorruptedStorage(): void {
    for (const key of Object.keys(this.cache)) {
      delete this.cache[key];
    }

    try {
      window.localStorage.removeItem(this.storageKey);
    } catch {
      this.isStorageAvailable = false;
    }
  }
}
